import React, { useContext } from "react";

import HoaAppLogV2 from "../../../hoa-app-log/hoa-app-log-V2";
import DocumentsComponent from "../hoa-view-documents";
import PropertiesComponent from "../hoa-view-properties";

import OverViewDetailsComponent from "./hoa-view-overview-details-component";
import ProcedureComponent from "./hoa-view-procedure-component";
import AmenitiesComponent from "./hoa-view-amenities-component";
import ViolationComponent from "./hoa-view-violation-component";

import { GlobalContext } from "../../../../context/hoa-global-context";

import { notAvailableComponentTitleByTabIndex } from "../../../../utility/helper";

import {
	getOverViewDetails,
	getProcedureDetails,
	getViolationDetails,
	getAmenitiesDetails,
} from "../../../../utility/formatted-hoa-values";

import useHoaViewController from "../../../../hooks/useHoaViewController";
import NoDataAvailable from "../../../../shared-components/hoa-no-data-available";
import { Stack } from "@mui/material";

export default function HoaViewMainComponent(props: any) {
	const {
		previousHoa,
		currentHoa,
		setCurrentHoa,
		tabIndex,
		selectedValues,
		newAmenitiesWarning,
		violationWarning,
		setDocumentWarning,
		height,
		procedureWarning,
		setReloadFutureEffectiveDateLog,
		restrictedFields,
		onboardingDataState
	} = props;

	const { hoa, updateSelectedValues, updateHoaData } = useContext<any>(GlobalContext);

	const {
		appLogs,
		isLogLoading,
		setAppLogs,
		updateLogLoading,
		getCreatedLogs,
		hoaProperties,
		setHoaProperties,
		onViewMunicipalityDetailsClick,
	} = useHoaViewController(selectedValues);

	const warnings = [
		{ condition: procedureWarning, index: 1 },
		{ condition: newAmenitiesWarning, index: 2 },
		{ condition: violationWarning, index: 3 },
	];

	const warning = warnings.find((w) => w.condition && tabIndex === w.index);
	if (warning) return <NoDataAvailable {...notAvailableComponentTitleByTabIndex(tabIndex)} />;

	return (
		<Stack style={{ height: height }}>
			{tabIndex === 0 ? (
				<OverViewDetailsComponent
					details={getOverViewDetails(selectedValues)}
					onViewMunicipalityDetailsClick={onViewMunicipalityDetailsClick}
					onboardingDataState={onboardingDataState}
				/>
			) : tabIndex === 1 ? (
				<ProcedureComponent details={getProcedureDetails(selectedValues)} />
			) : tabIndex === 2 ? (
				<AmenitiesComponent details={getAmenitiesDetails(selectedValues)} />
			) : tabIndex === 3 ? (
				<ViolationComponent
					details={getViolationDetails(selectedValues).ViolationDetails}
					tabDetails={getViolationDetails(selectedValues).violationTabsDetails}
				/>
			) : tabIndex === 4 ? (
				<DocumentsComponent
					hoa={hoa}
					previousHoa={previousHoa}
					currentHoa={currentHoa}
					setCurrentHoa={setCurrentHoa}
					updateSelectedValues={updateSelectedValues}
					documents={selectedValues.documents}
					selectedValues={selectedValues}
					updateHoaData={updateHoaData}
					setDocumentWarning={setDocumentWarning}
					style={{ height: height, overflowY: "auto" }}
					restrictedFields={restrictedFields.documentsRescrictedFields}
				/>
			) : tabIndex === 5 ? (
				<PropertiesComponent hoaProperties={hoaProperties} setHoaProperties={setHoaProperties} selectedValues={selectedValues} height={height} />
			) : (
				<HoaAppLogV2
					type={"Hoa"}
					appLogs={appLogs} 
					setAppLogs={setAppLogs} 
					getCreatedLogs={getCreatedLogs}
					isLogLoading={isLogLoading}
					updateLogLoading={updateLogLoading}
					height={height}
					setReloadFutureEffectiveDateLog={setReloadFutureEffectiveDateLog}
				/>
			)}
		</Stack>
	);
}
